import styled from "styled-components";

import Button from "@/components/Atoms/Button";

export const StyledPromoCodeApplyButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;
